// Module
var code = `{{name}}
`;
// Exports
module.exports = code;